import loadjs from "loadjs";
import kartStil from "./map-style";

window.housingMap = function() {
  return {
    mounted() {
      loadjs(
        "https://maps.googleapis.com/maps/api/js?key=AIzaSyBMC_D_vgbKaeskdLZHymPgwR8Boatq4gk",
        () => {
          initMap(
            this.mapCenter.lng,
            this.mapCenter.lat,
            this.mapZoom,
            this.bostaderPois
          );
        }
      );
    },
  };
};

function initMap(lng, lat, zoomLevel, places) {
  places = places || [];
  const stilig = false;
  var lngyLatty = new google.maps.LatLng(lat, lng);

  var stiligKarta = new google.maps.StyledMapType(kartStil, { name: "kartis" });

  var kartVal = {
    zoom: zoomLevel,
    disableDefaultUI: false,
    mapTypeControl: false,
    scrollwheel: false,
    backgroundColor: "#fafafa",
    center: lngyLatty,
    mapTypeControlOptions: {
      mapTypeIds: [google.maps.MapTypeId.ROADMAP, "map_style"],
    },
  };
  var kartan = new google.maps.Map(
    document.getElementById("gurgel-mepps"),
    kartVal
  );

  if (stilig) {
    kartan.mapTypes.set("map_style", stiligKarta);
    kartan.setMapTypeId("map_style");
  }

  var armadaSail = {
    path:
      "M23.3,23c0,0-1.4-4.3-2.1-10S20.7,2.1,20.7,2.1s-2,1.4-7.4,1.4S0,0,0,0s3.8,7.1,11.2,13.8S23.3,23,23.3,23z",
    fillColor: "#D28FBE",
    fillOpacity: 1,
    strokeColor: "#333333",
    strokeWeight: 1,
  };

  var infowindow = new google.maps.InfoWindow({
    content: "holding...",
  });

  if (places.length > 0) {
    for (var i = 0; i < places.length; i++) {
      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(places[i].lat, places[i].lng),
        map: kartan,
        title: "Plats",
        icon: armadaSail,
        html: `<div class="text-sm">
            <p class="font-bold mb-2">
              ${places[i].title}
            </p>

            <a class="block text-af-blue underline hover:text-af-pink" href="${places[i].link}">
            <img class="mb-2" width="150" src="${places[i].image}" />
              Gå till sida
            </a>
          </div>`,
      });

      google.maps.event.addListener(marker, "click", function() {
        infowindow.setContent(this.html);
        infowindow.open(kartan, this);
      });
    } /*endfor*/
  } else {
    var marker = new google.maps.Marker({
      position: lngyLatty,
      map: kartan,
      title: "Plats",
      icon: armadaSail,
    });
  }
}
